import $j from 'jquery';

export const hideIntercomWidget = hide => {
  if (hide) {
    $j('#intercom-container').hide();
  } else {
    $j('#intercom-container').show();
  }
};
